
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { isLight } from "@/lib/colors/colors";
import { Color } from "@/types/colors";

@Component
export default class ColorSwatch extends Vue {
  @Prop()
  value!: Color;

  @Prop()
  colorCode!: string | null;

  @Prop({ default: false })
  rounded!: boolean;

  get light() {
    if (!this.colorCode) {
      return true;
    }

    return isLight(this.colorCode);
  }
}
